export default __webpack_public_path__ + "static/media/pantro.a21277d3.jpeg";